// Saf SVG saat kadranı — harici görsel gerektirmez, her zaman yüklenir
export const WatchDial = ({ className = "" }) => {
  const ticks = Array.from({ length: 12 }, (_, i) => (i * 30 * Math.PI) / 180);
  return (
    <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
      <defs>
        <radialGradient id="dialBg" cx="50%" cy="38%" r="75%">
          <stop offset="0%" stopColor="#1B2A26" />
          <stop offset="100%" stopColor="#0E1A16" />
        </radialGradient>
      </defs>
      <circle cx="100" cy="100" r="97" fill="none" stroke="#C5A059" strokeOpacity="0.35" strokeWidth="1" />
      <circle cx="100" cy="100" r="88" fill="url(#dialBg)" stroke="#C5A059" strokeOpacity="0.8" strokeWidth="1.6" />
      {ticks.map((a, i) => {
        const x1 = 100 + Math.sin(a) * 76;
        const y1 = 100 - Math.cos(a) * 76;
        const x2 = 100 + Math.sin(a) * (i % 3 === 0 ? 64 : 69);
        const y2 = 100 - Math.cos(a) * (i % 3 === 0 ? 64 : 69);
        return (
          <line
            key={i}
            x1={x1} y1={y1} x2={x2} y2={y2}
            stroke="#C5A059"
            strokeWidth={i % 3 === 0 ? 2.2 : 1}
            strokeLinecap="round"
            strokeOpacity={i % 3 === 0 ? 0.95 : 0.55}
          />
        );
      })}
      <text x="100" y="72" textAnchor="middle" fill="#FAF8F5" fontSize="9.5" letterSpacing="2.5" fontFamily="'Cormorant Garamond', serif" fontWeight="600">
        ATILMAZ
      </text>
      <text x="100" y="83" textAnchor="middle" fill="#C5A059" fontSize="6" letterSpacing="4" fontFamily="'JetBrains Mono', monospace">
        SAAT
      </text>
      {/* Akrep 10:09 — klasik vitrin pozisyonu */}
      <line x1="100" y1="100" x2="100" y2="62" stroke="#FAF8F5" strokeWidth="2.6" strokeLinecap="round" transform="rotate(-55 100 100)" />
      <line x1="100" y1="100" x2="100" y2="48" stroke="#FAF8F5" strokeWidth="1.6" strokeLinecap="round" transform="rotate(56 100 100)" />
      <line x1="100" y1="106" x2="100" y2="40" stroke="#C5A059" strokeWidth="0.8" strokeLinecap="round" transform="rotate(150 100 100)" />
      <circle cx="100" cy="100" r="3.2" fill="#C5A059" />
      <circle cx="100" cy="100" r="1.4" fill="#0E1A16" />
      <text x="100" y="136" textAnchor="middle" fill="#FAF8F5" fillOpacity="0.45" fontSize="5" letterSpacing="2.2" fontFamily="'JetBrains Mono', monospace">
        EST. 2006
      </text>
    </svg>
  );
};
